<template>
    <SwitchRoot
        :id="id"
        v-model="inputValue"
        :class="[
            inputValue ?
                variant === 'error' ?
                    'bg-muval-red-1 hover:bg-muval-red-1'
                :   'bg-muval-brand hover:bg-brand-dark'
            :   'bg-muval-gray-4 hover:bg-muval-gray-3',
            size === 'sm' ? 'h-4 w-7' : 'h-5 w-10',
            'relative inline-flex shrink-0 cursor-pointer overflow-hidden rounded-full px-0.5 transition-colors duration-200 ease-in-out',
            hasError ? 'bg-red-200 focus:ring-red-600' : 'bg-gray-200',
        ]"
        @update:modelValue="
            (e) => {
                onInput(e);
            }
        "
    >
        <SwitchThumb
            :class="[
                inputValue ?
                    size === 'sm' ?
                        'translate-x-full'
                    :   'translate-x-[125%]'
                :   'translate-x-0',
                size === 'sm' ? 'h-3 w-3' : 'h-4 w-4',
                'shadow-muval-2 pointer-events-none my-auto inline-block transform rounded-full bg-white ring-0 transition duration-200 ease-in-out',
                hasError ? 'bg-error' : '',
            ]"
        >
            <template v-if="!loading && hasError">
                <svg
                    :class="[size === 'sm' ? 'h-3 w-3' : 'h-4 w-4', 'text-white']"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clip-rule="evenodd"
                    ></path>
                </svg>
            </template>
            <template v-if="loading">
                <SvgIcon
                    name="spinner"
                    class="text-muval-gray-3 h-full w-full animate-spin p-0.5"
                />
            </template>
        </SwitchThumb>
        <p
            v-if="errorMessage"
            class="absolute -bottom-3.5 text-xs font-normal"
            :class="errorMessage ? 'text-error' : ''"
        >
            {{ errorMessage }}
        </p>
    </SwitchRoot>
</template>
<script setup>
import { SwitchRoot, SwitchThumb } from 'reka-ui';
import { useField } from 'vee-validate';
import { idGen } from '../../utilities/idGen';
const emit = defineEmits(['update:modelValue']);

const props = defineProps({
    id: {
        type: [String, Number],
        required: true,
    },
    modelValue: {
        type: Boolean,
        required: true,
    },
    hasError: {
        type: Boolean,
        required: false,
        default: false,
    },
    loading: {
        type: Boolean,
        required: false,
        default: false,
    },
    vid: {
        type: String,
        required: false,
        default: () => idGen(6),
    },
    variant: {
        type: String,
        required: false,
        default: 'default',
        validator: (value) => ['default', 'error'].includes(value),
    },
    small: {
        type: Boolean,
        required: false,
        default: false,
    },
    size: {
        type: String,
        required: false,
        default: 'default',
        validator: (value) => ['default', 'sm'].includes(value),
    },
});

const {
    value: inputValue,
    errorMessage,
    handleChange,
} = useField(toRef(props, 'vid'), undefined, {
    initialValue: props.modelValue,
    valueProp: props.modelValue,
    validateOnValueUpdate: false,
});

const onInput = (event) => {
    handleChange(event, true);
};

watch(inputValue, (value) => {
    emit('update:modelValue', value);
});
</script>
